module.exports = __webpack_public_path__ + "static/img/hk.7428ec1c.svg";